import React from 'react';
import PropTypes from 'prop-types';
import SEO from './SEO';

// 預設 SEO（用於找不到 pageType 時）
const defaultSEO = {
  title: '凱撒數位科技股份有限公司 - 您的數位轉型夥伴',
  description: '凱撒數位科技專注於網站開發、數位行銷與AI導入，為企業提供創新且高效的數位解決方案。',
  keywords: '凱撒數位科技, 數位轉型, 網站設計, 系統開發, AI導入, 台灣',
  url: '/',
  image: '/assets/images/og-default.png',
};

// 各頁面的 SEO 設定
const seoConfig = {
  home: {
    title: '凱撒數位科技 - 專業的網站設計與開發服務',
    description: '凱撒數位科技提供高品質的網站設計、開發與數位行銷服務，幫助企業建立強大的線上形象。',
    keywords: '網站設計, 網站開發, 應用程式開發, 數位行銷, 台灣, React, 響應式設計',
    url: '/',
    image: '/assets/images/og-home.jpg',
  },
  about: {
    title: '關於凱撒數位科技 - 我們的團隊與使命',
    description: '了解凱撒數位科技的團隊、使命和價值觀。我們致力於為客戶提供創新的數位解決方案。',
    keywords: '關於我們, 凱撒科技, 團隊, 使命, 價值觀, 數位解決方案',
    url: '/about',
    image: '/assets/images/og-about.png',
  },
  services: {
    title: '服務項目 - 凱撒數位科技提供的專業服務',
    description: '探索凱撒數位科技提供的專業服務，包括網站設計、開發、數位行銷和企業系統整合。',
    keywords: '服務項目, 網站設計, 網站開發, 應用程式開發, 數位行銷, 企業系統整合',
    url: '/services',
    image: '/assets/images/og-services.png',
  },
  portfolio: {
    title: '作品集 - 凱撒數位科技的成功案例',
    description: '瀏覽凱撒數位科技的作品集，了解我們為客戶創造的成功案例和數位解決方案。',
    keywords: '作品集, 專案案例, 成功案例, 網站設計, 網站開發, 客戶案例',
    url: '/portfolio',
    image: '/assets/images/og-portfolio.png',
  },
  contact: {
    title: '聯絡凱撒科技 - 我們期待聽到您的聲音',
    description: '聯絡凱撒數位科技，讓我們了解您的項目需求，為您提供專業的網站設計與開發解決方案。',
    keywords: '聯絡我們, 凱撒數位科技, 網站設計, 客戶支援, 專案諮詢',
    url: '/contact',
    image: '/assets/images/og-contact.png',
  },
  blog: {
    title: '部落格 - 凱撒數位科技的最新技術與行業見解',
    description: '閱讀凱撒數位科技的部落格，獲取最新的技術見解、行業趨勢和專業知識。',
    keywords: '部落格, 技術見解, 行業趨勢, 網站設計, 數位行銷, 科技新聞',
    url: '/blog',
    image: '/assets/images/og-blog.png',
  },
};

/**
 * SEO 模板元件，根據頁面類型套用對應 SEO 設定
 * @param {string} pageType - 頁面代號（home, about, ...）
 * @param {object} customProps - 客製化覆蓋 SEO 屬性
 */
const SEOTemplate = ({ pageType, customProps = {} }) => {
  const pageConfig = seoConfig[pageType] || defaultSEO;

  // 合併 SEO 設定（customProps 可覆蓋預設）
  const seoProps = {
    ...pageConfig,
    ...customProps,
  };

  return <SEO {...seoProps} />;
};

SEOTemplate.propTypes = {
  pageType: PropTypes.oneOf([...Object.keys(seoConfig), undefined]).isRequired,
  customProps: PropTypes.object,
};

export default SEOTemplate;